import { useCallback, useEffect, useRef } from 'react';

export const useIsMounted = () => {
  const ref = useRef(false);
  const callback = useCallback(() => ref.current, []);

  useEffect(() => {
    ref.current = true;

    return () => {
      ref.current = false;
    };
  }, []);

  return callback;
};
